export default {
  list: {},
  loading: false,
  loaded: false,
  counts: undefined,
};
